import actions from '@/store/permissions/actions';

const permissionsModule = {
  state: () => ({
    permissions: [],
  }),
  getters: {
    sortedPermissions(state) {
      return state.permissions
        ? state.permissions.sort((a, b) => a.name.localeCompare(b.name))
        : [];
    },
  },
  mutations: {
    GET_PERMISSIONS_SUCCESS(state, data) {
      state.permissions = data;
    },
  },
  actions,
  namespaced: true,
};

export default permissionsModule;
